import React from 'react';

const UserContext = React.createContext({
  userToken: '',
  username: '',
  userTypeId: -1,
  isDragonflyUser: false,
  userRoles: [],
  useAutoSave: false,
  fontSizeMultiplier: 0,
  userTeams: [],
  applicationUserId: '',

  setUseAutoSave: (useAutoSave) => useAutoSave,
  setFontSizeMultiplier: (fontSizeMultiplier) => fontSizeMultiplier,
});

function useUserContext() {
  const context = React.useContext(UserContext);
  if (context === undefined) {
    throw new Error(
      'useUserContext must be used within a UserContext provider'
    );
  }
  return context;
}

export { UserContext, useUserContext };
